import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();

import { IWykrojnikRow } from "../IWykrojnikRow";
import { ITree } from "../../tree/ITree";
import { IWykrojnikParams } from "../params/IWykrojnikParams";
import { IWykrojnikiCostSvc, cost_api } from "./IWykrojnikiCostSvc";
import { IFin } from "../../fin/IFin";
import { WykrojnikSvc } from "../WykrojnikSvc";
import { IOferta } from "./IOferta";

export class WykrojnikiCostSvc implements IWykrojnikiCostSvc {

    public async zlecenia_kontrolne_przelicz_all():Promise<number|undefined> {
        const ret = await bus.call(cost_api.zlecenia_kontrolne_przelicz_all,{});
        if (!ret) return undefined;
        const count:number = ret.count;
        return count;
    }

    public async get_wykrojniki_z_kosztem(tree_id:any):Promise<IWykrojnikRow[]|undefined> {
        const body = {tree_id:tree_id}
        const ret = await bus.call(cost_api.get_wykrojniki_z_kosztem,body);

        if (ret) {
            await new WykrojnikSvc().get_selected_wykrojnik_for_tree(tree_id)  // update selection
            return (<IWykrojnikRow[]> ret);
        } 
        else return undefined
    }

    public async get_wykrojniki_z_kosztem_detailed(tree_id:any):Promise<IWykrojnikRow[]|undefined> {
        const body = {tree_id:tree_id}
        const ret = await bus.api(cost_api.get_wykrojniki_z_kosztem_detailed,body);

        if (ret) {
            await new WykrojnikSvc().get_selected_wykrojnik_for_tree(tree_id)  // update selection
            return (<IWykrojnikRow[]> ret);
        } 
        else return undefined
    }

    public async get_oferta(tree_id:any):Promise<IOferta|undefined> {
        const body = {tree_id:tree_id}

        const ret = await bus.call(cost_api.get_oferta,body);

        if (ret) {
            return ret;
        } 
        else return undefined
    }

    public async get_oferta_saved(tree_id:any):Promise<IOferta|undefined> {
        const body = {tree_id:tree_id}

        const ret = await bus.call(cost_api.get_oferta_saved,body);

        if (ret) {
            return ret;
        } 
        else return undefined
    }

    public async get_oferta_by_id(oferta_id:any):Promise<IOferta|undefined> {
        const body = {oferta_id:oferta_id}

        const ret = await bus.call(cost_api.get_oferta_by_id,body);

        if (ret) {
            return ret;
        } 
        else return undefined
    }

    public async save_oferta(oferta:IOferta):Promise<IOferta|undefined> {

        const ret = await bus.call(cost_api.save_oferta, oferta);

        if (ret) {
            return ret;
        } 
        else return undefined
    }


    public async get_oferty_arch_ids(tree_id:string):Promise<any[]> {
        const ret = await bus.call(cost_api.get_oferty_arch_ids, {tree_id: tree_id});
        return ret;
    }

    public async zlecenia_kontrolne_rezerwuj(tree_id:any, nakład_K_ist:number):Promise<any> {
        const body = {tree_id:tree_id, nakład_K_ist:nakład_K_ist}
        const ret = await bus.call(cost_api.zlecenia_kontrolne_rezerwuj,body);
        if (ret) {
            return ret;
        } 
        else return undefined
    }

}
      
  